import { render, staticRenderFns } from "./RemarkCard.vue?vue&type=template&id=cd4dcfba&scoped=true"
import script from "./RemarkCard.vue?vue&type=script&lang=js"
export * from "./RemarkCard.vue?vue&type=script&lang=js"
import style0 from "./RemarkCard.vue?vue&type=style&index=0&id=cd4dcfba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4dcfba",
  null
  
)

export default component.exports